export const LOAD_COMPANIES = 'companies/LOAD_COMPANIES';

